import React, { useEffect, useMemo, useRef, useState } from 'react'
import { DialogContainer, Grid, Cell, TextField, List, ListItem, Divider, Subheader, Dialog, Button, Checkbox } from 'react-md'
import { NotificationManager } from 'react-notifications';
import { BeatLoader } from 'react-spinners';

const PracticeSetDialog = ({showDialog, selectedCategories, handleCloseDialog, onCreatePracticeSet, topics}) => {

    const practiceNameRef = useRef(null);
    const [practiceName, setPracticeName] = useState('');

    const [pickedCategories, setPickedCategories] = useState([]);
    const [groupedCategories, setGroupedCategories] = useState([]);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        let newGroupedCategories = pickedCategories?.reduce((acc, cat) => {
            const { topicID, name } = cat;
            if (!acc[topicID]) {
              acc[topicID] = [];
            }
            acc[topicID].push({ ...cat });
            return acc;
          }, {});
          console.debug("newGroupedCategories", newGroupedCategories)
          setGroupedCategories(newGroupedCategories);
    }, [pickedCategories])

    useEffect(() => {
        if (showDialog) {
            let newSelectedCategories = selectedCategories.map(cat => {
                return {
                    ...cat,
                    checked: true,
                    key: `${cat.subjectID}_${cat.topicID}_${cat.categoryID}`
                }
            })
            console.debug("newSelectedCategories", newSelectedCategories)
            setPracticeName('')
            setPickedCategories(newSelectedCategories)
        } else {
            setPickedCategories([])
            setGroupedCategories([])
        }

        if (showDialog && practiceNameRef.current) {
            practiceNameRef.current.focus();
          }
    }, [showDialog])

    const handlePracticeNameChange = (value) => {
        setPracticeName(value);
    }

    const actions = [];
    actions.push(<Button 
        // className='cancel-btn' 
        secondary
        onClick={() => {
        setLoading(false);
        handleCloseDialog()
    }}>Cancel</Button>);
    actions.push(<Button 
        primary
        raised
        // className='save-btn' 
        onClick={() => {
        setLoading(false);
        let checkedCategories = pickedCategories?.filter(cat => cat.checked)
        if (!checkedCategories || checkedCategories.length === 0) {
            NotificationManager.warning("Please check atleast one category to create practice set", "No category checked", 2000);
            return
        }
        if (!practiceName || practiceName.length === 0) {
            NotificationManager.warning("Please enter a practice set name", "Empty Practice Set Name", 2000);
            return
        }
        setLoading(true);
        onCreatePracticeSet(practiceName, checkedCategories);
    }}>Save</Button>);




    const getTopicNameByID = (topicID) => {
        let topic = topics?.find(t => t.topicID == topicID)
        // console.debug("topic----", topic, topics, topicID)
        if (topic) {
            return topic.name + ':';
        }
        return ""
        
    }

    const handleChangeSelectedCategories = (catKey, val) => {
        let newPickedCategories = [...pickedCategories]
        console.debug("newPickedCategories" ,newPickedCategories, catKey)
        let index = newPickedCategories.findIndex(c => c.key === catKey)
        console.debug("index", index)
        if (index < 0) return;
        newPickedCategories[index].checked = val;
        console.debug("newPickedCategories", newPickedCategories)
        setPickedCategories(newPickedCategories);
    }

  return (
    <DialogContainer 
    visible={true} 
    id="practice-set-dialog"
    // className='practice-set-dialog'
    dialogStyle={{
        
    }}

    title="Create Practice Set"
    actions={actions}
    focusOnMount={false}
    style={{
      zIndex:"999"
    }}
    width="500px"
    onHide={() => handleCloseDialog()}
>

    {loading ? 
    <div style={{ textAlign: 'center', width: '100%', position: 'relative' }}><BeatLoader loading={loading} color={'#bb0000'} size={12} /></div>
    :
    <div className='px-3'>
    <TextField
        ref={practiceNameRef}
        id="practice-set-name-field"
        type='text'
        label="Practice Set Name"
        placeholder="Untitled Practice Set"
        inputStyle={{
            fontSize:"16px",
        }}

        value={practiceName}
        onChange={handlePracticeNameChange}
        required
        errorText="This field is required."
    />

    <div className='mt-3'>
        <div className='fontClass-18 font-weight-lighter'>Categories Selected:</div>
       {/*  <List>
            {selectedCategories && selectedCategories.map((cat, index) => {
                return <ListItem key={index} primaryText={cat.name} />
            })}
        </List> */}
        {Object.entries(groupedCategories).map(([topicID, categories]) => (
            <div className='mt-2'>
                <div className='fontClass-16 font-weight-bold'>{getTopicNameByID(topicID)}</div>
                <div key={topicID}>
                    {categories?.map((cat, index) => (
                    <div key={cat.key} className='d-flex justify-content-start align-items-center fontClass-14'> 
                        {/* <input type='checkbox' style={{
                            width:"18px",
                            height:"18px",
                            marginRight:"10px"
                        }} /> */}
                        <Checkbox checked={cat.checked} id={cat.key} onChange={(val) => {
                            console.debug("clcikced")
                            handleChangeSelectedCategories(cat.key, val);
                        }} />
                        {cat.name}
                    </div>
                    ))}
                </div>
            </div>
        ))}
    </div>
    </div>
    }
        
    
</DialogContainer>
  )
}

export default PracticeSetDialog